export const avatarAppConfig = {
  endPoint: "azr-hji-speech-service-endpoint",
  cogSvcRegion: "azr-hji-avatar-svc-region",
  cogSvcSubKey: "azr-hji-speech-svc-key",
  iceUrl: "azr-hji-avatar-svc-ice-url",
  iceUsername: "azr-hji-avatar-svc-ice-username",
  iceCredential: "azr-hji-avatar-svc-ice-credentials",
  voiceName: "en-US-JennyNeural",
  textToSpeechVoiceName: "en-US-AvaMultilingualNeural",
  avatarCharacter: "lisa",
  avatarStyle: "casual-sitting",
  avatarBackgroundColor: "#FFFFFFFF",
  iceEndPoint: "azr-hji-speech-service-ice-endpoint",
  iceKey: "azr-hji-speech-service-ice-key"
}

export const speechAppConfig = {
  speechSubKey: "azr-hji-speech-svc-key",
  speechEndpoint: "azr-hji-speech-service-endpoint"
}

export const apimUrlConfig = {
  apimUrl: "azr-hji-apim-url"
}
export const CONFIG = {
  docList: [
    'ppt',
    'doc',
    'pdf', 
    'oft'
  ]
};